import { Button } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

function CheckoutNavigation() {
  const history = useHistory();

  const backToCart = () => {
    history.push('/cart');
  };

  return (
    <div
      className={`d-flex justify-content-start mt-3 mb-2 ml-2`}
      style={{ left: '1.2rem', top: '6rem' }}
    >
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={backToCart}
        className="back-to-cart-button"
      >
        <FaArrowLeft className="mr-2" /> Voltar ao Carrinho
      </Button>
    </div>
  );
}

export default CheckoutNavigation;
